<script>
import getPasswordScore from '@/lib/getPasswordScore.js'
import { isEmpty } from 'lodash'
export default {
  methods: {
    getPasswordStrength(password) {
      const defaultStrength = { score: 0, color: 'blue-grey', text: '' }
      const score = getPasswordScore(password)

      if (isEmpty(password)) return defaultStrength
      if (score <= 40)
        return {
          score: 20,
          color: 'red',
          text: this.$t('profile_settings.weak'),
        }
      if (score <= 60)
        return {
          score: 40,
          color: 'orange',
          text: this.$t('profile_settings.medium'),
        }
      if (score <= 80)
        return {
          score: 70,
          color: 'yellow',
          text: this.$t('profile_settings.medium'),
        }
      if (score > 80)
        return {
          score: 100,
          color: 'green',
          text: this.$t('profile_settings.strong'),
        }

      return defaultStrength
    },
  },
}
</script>
